import { SET_MODAL_INACTIVITY } from '../actions/modalInactivity';
import { DEFAULT_VALUES_REDUCE } from 'src/components/Modal/constants/ModalInactivity/index';

const initialState = {
    ...DEFAULT_VALUES_REDUCE
};

function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SET_MODAL_INACTIVITY:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/modalInactivity.js